import { useCallback } from 'react';
import { replyToMessageTips } from '../../../../../shared/actions/matrixAction';
import {
  isCreatorMessagingOtherUser,
  splitCombinedMessage,
  normalizeMessageString,
} from '../../../../../shared/utils/chatUtil';

export function useSendTextMessageWithTipReply({
  sendTextMessage,
  isCreator,
  threadItems,
  destUserInfo,
  refreshRoomInfo,
}) {
  const sendTextMessageWithTipReply = useCallback(
    async (text) => {
      const trimmed = typeof text === 'string' ? text.trim() : '';
      if (!trimmed) return sendTextMessage(text);

      const isCreatorMessagingOtherUserInThread = isCreatorMessagingOtherUser(isCreator, threadItems, {
        maxThreadLength: 25,
        maxMyMessageCount: 0,
      });

      if (isCreatorMessagingOtherUserInThread) {
        const hasPendingFirstMessageTip = threadItems
          .filter((ti) => ti.type === 'message' && ti.item?.isMine === false)
          .some((ti) => {
            const raw = normalizeMessageString(ti.item?.message);

            // Prefer explicit JSON flag when available (new message-tip payloads).
            try {
              const parsed = JSON.parse(raw);
              if (parsed && typeof parsed === 'object' && parsed.isFirstMessageTip) {
                // Refunded tips must not trigger replyToMessageTips.
                if (parsed.isRefunded) return false;
                return true;
              }
            } catch (_) {
              // Not JSON – fall through to legacy detection below.
            }

            const [main, tip] = splitCombinedMessage(raw);
            return Boolean(main && tip);
          });

        if (hasPendingFirstMessageTip) {
          const subscriberUserId = destUserInfo?._id;
          if (subscriberUserId) {
            const response = await replyToMessageTips(subscriberUserId, trimmed);
            if (response?.success) {
              refreshRoomInfo?.();
            }
          }
          return sendTextMessage(text);
        }
      }

      //TODO:: also call api here
      return sendTextMessage(text);
    },
    [sendTextMessage, isCreator, threadItems, destUserInfo, refreshRoomInfo]
  );

  return sendTextMessageWithTipReply;
}

